import { ClientApi } from './pos-client';
import config from '@/config';

const { apiKey, secret, baseUrl, deviceId, osTicketUrl, irsUrl } = config;

class Api {
  _clientPos = null;

  _IRSClientPos = null;

  constructor() {
    this._url = baseUrl;
    this._apiKey = apiKey;
    this._secret = secret;
    this._deviceId = deviceId;
    this._token = null;
  }

  _buildToken() {
    return `${this._token}`;
  }

  autoRefreshToken(timeout = 3000000) {
    setInterval(() => {
      this._IRSClientPos.refresh();
    }, timeout);
  }

  refreshToken = () => {
    return this._IRSClientPos.refresh();
  };

  async init() {
    return this._clientPos.getConfig();
  }

  getAPiOsTicket() {
    return this.createPostClientInstance(osTicketUrl);
  }

  getApiIRS() {
    if (this._IRSClientPos) return this._IRSClientPos;
    this._IRSClientPos = new ClientApi(`${irsUrl}/api`, this._apiKey, this._secret, this._deviceId);
    return this._IRSClientPos;
  }

  createPostClientInstance(url) {
    this._clientPos = new ClientApi(url, this._apiKey, this._secret, this._deviceId);
    return this._clientPos;
  }

  getApi() {
    if (this._clientPos) {
      return this._clientPos;
    }
    return this.createPostClientInstance(baseUrl);
  }
}

export default new Api(baseUrl);
